export function systemErrorMessages(): Record<
  string,
  { [key: string]: string }
> {
  return {
    API_DUPLICATES: {
      es: "Registros duplicados",
      en: "Duplicate records",
      pt: "Registros duplicados",
    },

    MAIL_SEND_FAILED: {
      es: "Error en el envío de email",
      en: "Email sending failed",
      pt: "Erro no envio do email",
    },

    // AUTH_* para errores de autenticación/autorización
    AUTH_UNAUTHORIZED: {
      es: "No autorizado para esta operación",
      en: "Not authorized for this operation",
      pt: "Não autorizado para esta operação",
    },

    AUTH_CREDENTIALS_REQUIRED: {
      es: "Tenés que ingresar al sistema con usuario y contraseña",
      en: "Must login with username and password",
      pt: "Deve entrar no sistema com usuário e senha",
    },

    // PAGINATION_* para errores de paginación
    PAGINATION_SIZE_EXCEEDED: {
      es: "Tamaño de página demasiado grande",
      en: "Page size too large",
      pt: "Tamanho da página muito grande",
    },
    PAGINATION_OFFSET_EXCEEDED: {
      es: "Salto de filas en base de datos demasiado grande",
      en: "Database row offset too large",
      pt: "Deslocamento de linhas no banco de dados muito grande",
    },

    // RECORD_* para errores relacionados con registros
    RECORD_NOT_FOUND: {
      es: "No existe",
      en: "Does not exist",
      pt: "Não existe",
    },
    // La escritura encontró el registro con otra versión que la que leyó el
    // formulario. El reintento del mismo guardado de un formulario se reconoce y
    // no llega acá (la clave de idempotencia); el de una transición de workflow,
    // que no la lleva, sí: por eso el texto nombra también un intento anterior
    // del mismo usuario que sí se guardó.
    RECORD_MODIFIED: {
      es: "No se pudo guardar: el registro cambió desde que lo abriste (lo modificó otra persona, otra pestaña, un proceso o un intento anterior tuyo que sí se guardó). Recargá para ver los datos actuales.",
      en: "Could not save: the record has changed since you opened it (it was modified by another person, another tab, a process or an earlier attempt of yours that did get saved). Reload to see the current data.",
      pt: "Não foi possível salvar: o registro mudou desde que você o abriu (foi modificado por outra pessoa, outra aba, um processo ou uma tentativa anterior sua que chegou a ser salva). Recarregue para ver os dados atuais.",
    },
    // Un borrado rechazado porque el registro está en uso. El mensaje lo arma
    // el cliente con los datos que manda el server (deletionBlockersText).
    ENTITY_IN_USE: {
      es: "No se puede borrar",
      en: "Cannot delete",
      pt: "Não é possível excluir",
    },

    // VALIDATION_* para errores de validación
    VALIDATION_REQUIRED: {
      es: "El campo debe tener un valor",
      en: "Field must have a value",
      pt: "O campo deve ter um valor",
    },

    // SYSTEM_* para errores del sistema
    SYSTEM_UNKNOWN_ERROR: {
      es: "Error imprevisto",
      en: "Unexpected error",
      pt: "Erro inesperado",
    },

    // NAVIGATION_* para errores de navegación
    NAVIGATION_NO_CURRENT_FRAME: {
      es: "No hay frame de navegación activo",
      en: "No current navigation frame",
      pt: "Nenhum frame de navegação ativo",
    },
    NAVIGATION_FRAME_NOT_FOUND: {
      es: "Frame de navegación no encontrado",
      en: "Navigation frame not found",
      pt: "Frame de navegação não encontrado",
    },
    NAVIGATION_STORE_CREATION_FAILED: {
      es: "Error al crear store de navegación",
      en: "Failed to create navigation store",
      pt: "Falha ao criar armazenamento de navegação",
    },
    NAVIGATION_INVALID_PATHNAME: {
      es: "Pathname inválido para navegación",
      en: "Invalid pathname for navigation",
      pt: "Pathname inválido para navegação",
    },
    NAVIGATION_CACHE_EVICTION: {
      es: "Frame eliminado por política de caché",
      en: "Frame evicted by cache policy",
      pt: "Frame removido pela política de cache",
    },

    // Errores de conexión y base de datos
    P1000: {
      es: "Error de autenticación con la base de datos",
      en: "Authentication failed with database",
      pt: "Falha na autenticação com o banco de dados",
    },
    P1001: {
      es: "No se puede conectar a la base de datos",
      en: "Cannot connect to database",
      pt: "Não é possível conectar ao banco de dados",
    },
    P1002: {
      es: "Tiempo de espera agotado para la base de datos",
      en: "Database connection timed out",
      pt: "Tempo limite de conexão com o banco de dados",
    },

    // Errores de restricciones
    P2002: {
      es: "Registro duplicado en campo único",
      en: "Unique constraint failed",
      pt: "Violação de restrição única",
    },
    P2003: {
      es: "Violación de restricción de clave foránea",
      en: "Foreign key constraint failed",
      pt: "Violação de chave estrangeira",
    },
    P2004: {
      es: "Restricción en base de datos no satisfecha",
      en: "Database constraint failed",
      pt: "Restrição do banco de dados não satisfeita",
    },

    // Errores de registros
    P2001: {
      es: "El registro buscado no existe",
      en: "Record does not exist",
      pt: "Registro não existe",
    },
    P2005: {
      es: "Valor inválido en el campo",
      en: "Invalid field value",
      pt: "Valor de campo inválido",
    },
    P2006: {
      es: "Valor proporcionado no válido para el tipo de campo",
      en: "The provided value is invalid for the field type",
      pt: "O valor fornecido é inválido para o tipo do campo",
    },
    P2007: {
      es: "Error de validación de datos",
      en: "Data validation error",
      pt: "Erro de validação de dados",
    },

    // Errores de transacciones
    P2012: {
      es: "Falta un campo requerido",
      en: "Missing a required field",
      pt: "Campo obrigatório ausente",
    },
    P2013: {
      es: "Falta un argumento requerido",
      en: "Missing required argument",
      pt: "Argumento obrigatório ausente",
    },
    P2014: {
      es: "El cambio violaría una relación requerida",
      en: "The change would violate a required relation",
      pt: "A alteração violaria uma relação obrigatória",
    },
    P2015: {
      es: "Registro relacionado no encontrado",
      en: "Related record not found",
      pt: "Registro relacionado não encontrado",
    },

    // Errores de consulta
    P2021: {
      es: "La tabla especificada no existe",
      en: "The specified table does not exist",
      pt: "A tabela especificada não existe",
    },
    P2022: {
      es: "La columna especificada no existe",
      en: "The specified column does not exist",
      pt: "A coluna especificada não existe",
    },
    P2025: {
      es: "Operación fallida por registro requerido no encontrado",
      en: "Operation failed because required record was not found",
      pt: "Operação falhou porque registro obrigatório não foi encontrado",
    },

    // Errores de tipo
    P2030: {
      es: "Valor fuera del rango permitido",
      en: "Value out of range",
      pt: "Valor fora do intervalo permitido",
    },
  };
}

/**
 * Las frases de "por qué no se puede borrar". Las arma
 * src/common/deletion/deletionBlockersText.ts con los datos que manda el server
 * (entidades, ids, nombres visibles y cantidades) y las etiquetas de cada
 * entidad (singular, plural y género). En castellano se dice "formulario".
 */
export type DeletionGender = "F" | "M";

export type DeletionBlockersPhrases = {
  /** "la editorial «ULTRA»" o, sin nombre, "esta editorial". */
  target: (
    singular: string,
    gender: DeletionGender,
    display?: string
  ) => string;
  /** "No se puede borrar la editorial «ULTRA»". */
  title: (target: string) => string;
  /** Primera línea del texto: "No se puede borrar la editorial «ULTRA» porque la usan:". */
  usedBy: (title: string, gender: DeletionGender) => string;
  /** Todos los motivos sin cantidades (la red de seguridad sobre la base). */
  usedByUnknown: (
    title: string,
    gender: DeletionGender,
    roots: string
  ) => string;
  /** Los formularios del propio registro que lo usan (la raíz es la misma entidad): "formularios de destinatario del propio registro". */
  ownForms: (models: string) => string;
  /** Todos los motivos son de los propios formularios del registro. */
  usedByOwn: (
    title: string,
    gender: DeletionGender,
    ownForms: string
  ) => string;
  /** Un motivo sin cantidades entre otros que sí las tienen. */
  someForms: string;
  /** "3 más" */
  more: (n: number) => string;
  /** "2 formularios que no están a la vista" */
  hidden: (n: number) => string;
  /**
   * Suma los formularios ocultos al final de una lista ya armada: "plain" (solo
   * nombres: "Aire y 2 formularios…"), "more" (la lista cierra con "N más": "…y 4 más,
   * y otros 2 formularios…") o "count" (la lista es una cantidad: "3 formularios y
   * otros 2 que…"). Así no se repite la palabra.
   */
  addHidden: (
    list: string,
    n: number,
    kind: "plain" | "more" | "count"
  ) => string;
  /** Palabra genérica para una entidad sin etiqueta: nunca el identificador del server. */
  record: string;
  /** Lo mismo en plural, como encabezado de una línea. */
  records: string;
  /** "12 formularios de otras empresas" */
  otherTenants: (n: number) => string;
  /** Auditoría, el creador del registro (createdBy_). */
  createdBy: (n: number) => string;
  /** Auditoría, la empresa del registro (tenant_). */
  ofTenant: (n: number) => string;
  /** Cantidad sin más detalle. */
  forms: (n: number) => string;
  /** La conjunción antes del último elemento de una lista, con sus espacios. */
  and: (next: string) => string;
  /** El diálogo de confirmación mientras consulta si se puede borrar. */
  checking: string;
  /** El diálogo de confirmación mientras se borra. */
  deleting: string;
  /** El resultado de un borrado múltiple que no borró todo. */
  multiDeleteTitle: (deleted: number, total: number) => string;
  /** Un registro del borrado múltiple que el server rechazó. */
  multiDeleteFailed: (display: string, message: string) => string;
};

export function deletionBlockersMessages(): Record<
  "es" | "en" | "pt",
  DeletionBlockersPhrases
> {
  const hiddenEs = (n: number) =>
    n === 1
      ? "1 formulario que no está a la vista"
      : `${n} formularios que no están a la vista`;
  const hiddenEn = (n: number) =>
    n === 1 ? "1 form you cannot see" : `${n} forms you cannot see`;
  const hiddenPt = (n: number) =>
    n === 1
      ? "1 formulário que você não pode ver"
      : `${n} formulários que você não pode ver`;
  return {
    es: {
      target: (singular, gender, display) =>
        display
          ? `${gender === "F" ? "la" : "el"} ${singular} «${display}»`
          : `${gender === "F" ? "esta" : "este"} ${singular}`,
      title: (target) => `No se puede borrar ${target}`,
      usedBy: (title, gender) =>
        `${title} porque ${gender === "F" ? "la" : "lo"} usan:`,
      usedByUnknown: (title, gender, roots) =>
        `${title}: ${
          gender === "F" ? "la" : "lo"
        } usan uno o más formularios de ${roots}.`,
      ownForms: (models) => `formularios de ${models} del propio registro`,
      usedByOwn: (title, gender, ownForms) =>
        `${title}: ${gender === "F" ? "la" : "lo"} usan ${ownForms}.`,
      someForms: "uno o más formularios",
      more: (n) => `${n} más`,
      hidden: hiddenEs,
      addHidden: (list, n, kind) =>
        kind === "plain"
          ? `${list} y ${hiddenEs(n)}`
          : kind === "more"
          ? n === 1
            ? `${list}, y otro formulario que no está a la vista`
            : `${list}, y otros ${n} formularios que no están a la vista`
          : n === 1
          ? `${list} y otro que no está a la vista`
          : `${list} y otros ${n} que no están a la vista`,
      record: "registro",
      records: "Registros",
      otherTenants: (n) =>
        n === 1
          ? "1 formulario de otra empresa"
          : `${n} formularios de otras empresas`,
      createdBy: (n) =>
        n === 1 ? "1 formulario que creó" : `${n} formularios que creó`,
      ofTenant: (n) =>
        n === 1
          ? "1 formulario de la empresa"
          : `${n} formularios de la empresa`,
      forms: (n) => (n === 1 ? "1 formulario" : `${n} formularios`),
      // "y" pasa a "e" antes del sonido de la i: "Juan e Ignacio", pero "Juan y Hielo".
      and: (next) => (/^h?[ií](?![aeouáéóú])/i.test(next) ? " e " : " y "),
      checking: "Verificando si se puede borrar…",
      deleting: "Borrando…",
      multiDeleteTitle: (deleted, total) =>
        deleted === 0
          ? "No se pudo borrar ninguno"
          : deleted === 1
          ? `Se borró 1 de ${total}`
          : `Se borraron ${deleted} de ${total}`,
      multiDeleteFailed: (display, message) => `«${display}»: ${message}`,
    },
    en: {
      target: (singular, _gender, display) =>
        display ? `the ${singular} "${display}"` : `this ${singular}`,
      title: (target) => `Cannot delete ${target}`,
      usedBy: (title) => `${title} because it is used by:`,
      usedByUnknown: (title, _gender, roots) =>
        `${title}: it is used by one or more ${roots} forms.`,
      ownForms: (models) => `its own ${models} forms`,
      usedByOwn: (title, _gender, ownForms) =>
        `${title}: it is used by ${ownForms}.`,
      someForms: "one or more forms",
      more: (n) => `${n} more`,
      hidden: hiddenEn,
      addHidden: (list, n, kind) =>
        kind === "plain"
          ? `${list} and ${hiddenEn(n)}`
          : kind === "more"
          ? `${list}, plus ${
              n === 1 ? "1 other form" : `${n} other forms`
            } you cannot see`
          : `${list} and ${n} more you cannot see`,
      record: "record",
      records: "Records",
      otherTenants: (n) =>
        n === 1
          ? "1 form from another company"
          : `${n} forms from other companies`,
      createdBy: (n) =>
        n === 1 ? "1 form they created" : `${n} forms they created`,
      ofTenant: (n) =>
        n === 1 ? "1 form of the company" : `${n} forms of the company`,
      forms: (n) => (n === 1 ? "1 form" : `${n} forms`),
      and: () => " and ",
      checking: "Checking whether it can be deleted…",
      deleting: "Deleting…",
      multiDeleteTitle: (deleted, total) =>
        deleted === 0
          ? "None could be deleted"
          : `${deleted} of ${total} deleted`,
      multiDeleteFailed: (display, message) => `"${display}": ${message}`,
    },
    pt: {
      target: (singular, gender, display) =>
        display
          ? `${gender === "F" ? "a" : "o"} ${singular} "${display}"`
          : `${gender === "F" ? "esta" : "este"} ${singular}`,
      title: (target) => `Não é possível excluir ${target}`,
      usedBy: (title, gender) =>
        `${title} porque é ${gender === "F" ? "usada" : "usado"} por:`,
      usedByUnknown: (title, gender, roots) =>
        `${title}: é ${
          gender === "F" ? "usada" : "usado"
        } por um ou mais formulários de ${roots}.`,
      ownForms: (models) => `formulários de ${models} do próprio registro`,
      usedByOwn: (title, gender, ownForms) =>
        `${title}: é ${gender === "F" ? "usada" : "usado"} por ${ownForms}.`,
      someForms: "um ou mais formulários",
      more: (n) => `mais ${n}`,
      hidden: hiddenPt,
      addHidden: (list, n, kind) =>
        kind === "plain"
          ? `${list} e ${hiddenPt(n)}`
          : kind === "more"
          ? `${list}, além de ${
              n === 1 ? "1 outro formulário" : `${n} outros formulários`
            } que você não pode ver`
          : `${list} e ${
              n === 1 ? "1 outro" : `${n} outros`
            } que você não pode ver`,
      record: "registro",
      records: "Registros",
      otherTenants: (n) =>
        n === 1
          ? "1 formulário de outra empresa"
          : `${n} formulários de outras empresas`,
      createdBy: (n) =>
        n === 1 ? "1 formulário que criou" : `${n} formulários que criou`,
      ofTenant: (n) =>
        n === 1 ? "1 formulário da empresa" : `${n} formulários da empresa`,
      forms: (n) => (n === 1 ? "1 formulário" : `${n} formulários`),
      and: () => " e ",
      checking: "Verificando se pode ser excluído…",
      deleting: "Excluindo…",
      multiDeleteTitle: (deleted, total) =>
        deleted === 0
          ? "Nenhum pôde ser excluído"
          : deleted === 1
          ? `1 de ${total} excluído`
          : `${deleted} de ${total} excluídos`,
      multiDeleteFailed: (display, message) => `"${display}": ${message}`,
    },
  };
}
